/**
 * Frontend utilities for matching exercise outcomes against personal record data.
 * The getFullName function must stay in sync with the backend version at
 * msb-api/lib/utils/personal-records.js
 */

/**
 * Returns the full name of an exercise used as a grouping key.
 * Must match the backend getFullName in msb-api/lib/utils/personal-records.js
 */
export function getFullName(exercise) {
  const secondary = exercise.secondary || "";
  if (exercise.type === "assistant") return secondary;
  return `${exercise.primary}${secondary ? ` ${secondary}` : ""}`;
}

/**
 * Checks if a specific set outcome qualifies as a personal record.
 * @param {Object} exercise - The exercise object (needs type, primary, secondary)
 * @param {Object} outcome - The outcome object { status, outcome: { reps, load, ... } }
 * @param {Object} repMaxPR - The repMaxPR data from the personal-records endpoint
 * @returns {{ reps: number } | null} - The rep count if it's a PR, or null
 */
export function isPROutcome(exercise, outcome, repMaxPR, exerciseDate = null) {
  if (!outcome || outcome.status !== "completed") return null;
  const rpe = outcome.outcome?.rpe;
  if (rpe && rpe !== "AMRAP" && Number(rpe) < 7) return null;
  const reps = String(outcome.outcome?.reps);
  if (!reps || reps === "0") return null;
  const key = getFullName(exercise);
  const prData = repMaxPR?.[key]?.[reps];
  if (prData && prData.load === outcome.outcome?.load && (prData.delta == null || prData.delta >= 0)) {
    if (exerciseDate && prData.date && prData.date.slice(0, 10) !== exerciseDate) {
      return null;
    }
    return { reps: Number(reps) };
  }
  return null;
}
